<template>
  <card class="culture-card" ref="cultureCard">
    <template v-slot:header>
      <h5 class="mb-2">CULTURA  {{ client && client.name ? client.name : 'VEGETAL' }}</h5>
      <h3 class="mb-0">{{ culture.description || culture.culture_name }}</h3>
    </template>
    <div class="card-deck flex-column flex-md-row">
      <div class="col-md-8 col-12 px-0 px-md-3">
        <div>
          <label class="form-control-label mb-2">Ciclo Padrão</label><br />
          <multiselect
            v-model="cicleChoose"
            :options="ciclesOptions"
            placeholder="Selecione um ciclo"
            label="description"
            track-by="id"
            :loading="isLoadingOptions"
            @search-change="loadCiclesOptions"
            @select="editCicle"
          ></multiselect>
        </div>
        <div
          class="card-deck"
          style="padding: 10px 40px 0 10px;"
        >
          <div class="col-3 px-2 d-none d-sm-block"><span class="h5">Ciclos</span></div>
          <div class="col-3 px-2 d-none d-sm-block"><span class="h5">Periodo</span></div>
          <div class="col-3 px-2 d-none d-sm-block"><span class="h5">Classificação</span></div>
          <div class="col-2 px-2 d-none d-sm-block"><span class="h5">Indice Tec.</span></div>
          <div class="col-12 col-sm-1 pb-2 float-right">
            <base-button size="sm" type="primary" @click="newCicle()">Novo</base-button>
          </div>
        </div>
        <dynamic-list
          class="cicles-list"
          :actions="true"
          :list="cicles"
          itemName="description"
          :itemKey="(item) => JSON.stringify(item)"
          @item-selected="setSelectedCicle"
        >
          <template v-slot:title="{ item, isSelected }">
            <div class="col text-left">
              <div class="row">
                <div
                  :class="{ 'text-white': isSelected }"
                  class="col-12 col-sm-3 h4 ml--2"
                >
                  <span class="d-sm-none">Ciclos: </span>
                  {{ item.description }}
                </div>
                <div class="col-12 col-sm-3 px-2">
                  <!-- <time-snake
                    v-if="crop"
                    :snakeStartDate="new Date(crop.start_date)"
                    :snakeEndDate="new Date(crop.end_date)"
                    :startDate="new Date(item.plantingStart)"
                    :endDate="new Date(item.end)"
                  /> -->
                </div>
                <div :class="{ 'text-white': isSelected }" class="col-12 col-sm-3 px-2 h4">
                  <span class="d-sm-none">Classificação: </span>
                  {{
                    item.cicle_classification
                      ? item.cicle_classification.name
                      : "Sem classificação"
                  }}
                </div>
                <div :class="{ 'text-white': isSelected }" class="col-12 col-sm-3 px-2 h4">
                  <span class="d-sm-none">Indice Tecnológico: </span>
                  {{
                    item.technological_index.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "brl",
                    })
                  }}
                </div>
              </div>
            </div>
          </template>
          <template v-slot:actions="{ item }">
            <a class="dropdown-item" href="#" @click="editCicle(item)"
              >Editar</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click="modals.technologicalIndex = true"
              >Indice Tecnológico</a
            >
            <a class="dropdown-item" href="#" @click="destroyCicle(item)"
              >Excluir</a
            >
            <a
              class="dropdown-item"
              href="#"
              v-if="!client"
              @click="duplicateCicle(item)"
              >Copiar</a
            >
          </template>
        </dynamic-list>

        <div style="height: 70px;" v-if="isLoading" v-loading="isLoading"></div>
      </div>
      <div class="col-md-4 col-12 px-0 px-md-3" style="position: relative; min-height: 400px;">
        <bar-chart
          ref="ciclesChart"
          style="position: absolute; top: 50%; transform: translateY(-50%); width: 100%;"
          :chart-data="chartData()"
        ></bar-chart>
      </div>
    </div>
    <!-- New culture modal -->
    <modal :show.sync="modals.cicleForm" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">
          {{ selectedCicle.id ? "Editar" : "Cadastrar" }} Ciclo
        </h5>
      </template>
      <cicle-form
        ref="cicleForm"
        v-model="selectedCicle"
        :culture="culture"
        :copy-cicle="copyCicle"
      />
      <template slot="footer">
        <base-button type="secondary" @click="modals.cicleForm = false">Fechar</base-button>
        <base-button type="success" @click="saveCicle()">Salvar</base-button>
      </template>
    </modal>

    <!-- Technological index modal -->
    <technological-index-modal
      :show.sync="modals.technologicalIndex"
      :cicle.sync="selectedCicle"
    ></technological-index-modal>
  </card>
</template>

<script>
import CicleForm from "@/views/Cicles/CicleForm";
import TechnologicalIndexModal from "@/views/Cicles/TechnologicalIndexModal";
import DynamicList from "@/components/DynamicList/DynamicList";
import TimeSnake from "@/components/Snakes/TimeSnake";
import BarChart from "@/components/Charts/BarChart";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

export default {
  components: {
    CicleForm,
    TechnologicalIndexModal,
    DynamicList,
    TimeSnake,
    BarChart,
    Multiselect,
    error: [],
  },
  props: {
    culture: {
      type: Object,
      required: false,
    },
    crop: {
      type: Object,
      required: true,
    },
    client: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      canCreate: true,
      isLoading: true,
      isLoadingOptions: true,
      copyCicle: false,
      selectedCicle: {},
      modals: {
        cicleForm: false,
        technologicalIndex: false,
      },
      cicles: [],
      cicleChoose: {},
    };
  },
  methods: {
    newCicle() {
      this.selectedCicle = {};
      this.copyCicle = false;
      this.cicleChoose = this.cicle; 
      this.modals.cicleForm = true;
    },
    editCicle(cicle) {
      this.copyCicle = false;
      this.selectedCicle = Object.assign({}, cicle);
      if (this.client) {
        this.selectedCicle.client = this.client;
        this.selectedCicle.client_id = this.client.id;
      }
      this.cicleChoose = cicle;
      this.modals.cicleForm = true;
    },
    duplicateCicle(cicle) {
      this.selectedCicle = Object.assign({}, cicle);
      this.copyCicle = true;
      this.modals.cicleForm = true;
    },
    setSelectedCicle(cicle) {
      this.selectedCicle = cicle;
    },
    async destroyCicle(cicle) {
      try {
        await this.$http.secured.delete(`/api/v1/cicles/${cicle.id}`);

        this.loadCicles();
        this.loadCiclesOptions()
        this.cicleChoose = {}

        const index = this.cicleChoose.indexOf(cicle.id);
        if (index !== -1) {
          this.cicleChoose.splice(index, 1);
        }
      } catch (error) {
        Object.values(error.response.data)
          .flat()
          .forEach((msg) => this.$toasted.global.defaultError({ msg: msg }));
      }
    },
    async loadCicles(anosafra_id) {
      var q = null;
      if (!this.client) {
        q = { client_id: [0, null], anosafra_id: anosafra_id, culture_id: this.culture.id };
      } else {
        q = { client_id: this.client.id, anosafra_id: anosafra_id, culture_id: this.culture.id };
      }

      try {
        const response = await this.$http.secured.get(`/api/v1/cicles`, {
          params: {
            q: q,
          },
        });

        this.cicles = response.data;
        this.isLoading = false; 
      } catch (error) {
        this.isLoading = false; 
        console.error("Error loading cicles:", error); 

      }
    },

    async loadCiclesOptions() {
      const params = {
        standard_cycle: true,
        client_id: this.client ? this.client.id : null,
        culture_id: this.culture ? this.culture.id : null
      };

      try {
        const response = await this.$http.secured.get(`/api/v1/cicles`, { params });
        
        this.ciclesOptions = response.data;
        this.isLoadingOptions = false;
      } catch (error) {
        this.$toasted.global.defaultError({ msg: 'Erro ao carregar ciclos' });
        this.isLoadingOptions = false;
      }
    },

    saveCicle() {
      // Validating client id presence
      if (this.copyCicle && !(this.selectedCicle.client_id || this.selectedCicle.client)) {
        this.$toasted.global.defaultError({
          msg: "Selecione um cliente para o ciclo",
        });
        return;
      }
      // Validating Identificação id presence
      if (!this.selectedCicle.description) {
        this.$toasted.global.defaultError({
          msg: "Selecione uma Identificação para o ciclo",
        });
        return;
      }
      // Validating cicle_classification id presence
      if (!this.selectedCicle.cicle_classification) {
        this.$toasted.global.defaultError({
          msg: "Selecione uma classificação para o ciclo",
        });
        return;
      }
      // Validating anosafra presence
      if (!this.selectedCicle.anosafra_id) {
        this.$toasted.global.defaultError({
          msg: "Selecione um Ano Safra para o ciclo",
        });
        return;
      }

      // Validating prePlantingStart presence
      if (!(
        this.selectedCicle.prePlantingStart
        && this.selectedCicle.plantingStart
        && this.selectedCicle.growingStart
        && this.selectedCicle.harvestStart
        && this.selectedCicle.end
      )) {
        this.$toasted.global.defaultError({
          msg: "Preencha as Fases do ciclo",
        });
        return;
      }

      if (this.selectedCicle.client) {
        this.selectedCicle.client_id = this.selectedCicle.client.id;
      }

      if (this.copyCicle && this.selectedCicle.technological_indexes) {
        this.selectedCicle.technological_indexes_attributes = this.selectedCicle.technological_indexes.map(
          ({ id, cicle_id, ...rest }) => rest
        );
      }

      if (this.selectedCicle.description != null) {
        if (this.client && this.client.id) {
          this.selectedCicle.client_id = this.client.id;
        }

        this.selectedCicle.culture_id = this.culture.id;

        if (this.selectedCicle.id) {
          if (this.copyCicle) {
            this.selectedCicle.id = null;
            this.createCicle(this.selectedCicle);
            this.copyCicle = false;
          } else this.updateCicle(this.selectedCicle);
        } else {
          this.createCicle(this.selectedCicle);
        }
      } else {
        this.modals.cicleForm = false;
      }
      this.loadCiclesOptions();
    },
    async createCicle(cicle) {
      try {
        const response = await this.$http.secured.post(`/api/v1/cicles`, { cicle: cicle });
        
        if (response.data.client_id === 0) {
          this.cicles.push(response.data);
          this.cicleChoose = response.data;
        }

        await this.loadCiclesOptions();
        await this.loadCicles();
        this.cicleChoose = {};
        this.$toasted.global.defaultSuccess();
        this.modals.cicleForm = false;
      } catch (error) {
        this.$toasted.global.defaultError({ msg: error });
      }
    },

    updateCicle(cicle) {
      this.$http.secured
        .put(`/api/v1/cicles/${cicle.id}`, cicle)
        .then((response) => {
          this.selectedCicle = response.data;
          this.modals.cicleForm = false;
          this.$toasted.global.defaultSuccess();
          this.loadCicles();
        })
        .catch((error) => {
           this.$toasted.global.defaultError({ msg: error })
        });
    },
    chartData() {
      return {
        labels: this.cicles.map((cicle) => cicle.description),
        datasets: [
          {
            label: "Agroquimico",
            backgroundColor: "#11cdef",
            data: this.cicles.map((cicle) =>
              cicle.agrochemicals_index.toFixed(2)
            ),
          },
          {
            label: "Semente",
            backgroundColor: "#2dce89",
            data: this.cicles.map((cicle) => cicle.seeds_index.toFixed(2)),
          },
          {
            label: "Nutrição",
            data: this.cicles.map((cicle) => cicle.nutritions_index.toFixed(2)),
          },
          {
            label: "Outros",
            backgroundColor: "#172b4d",
            data: this.cicles.map((cicle) => cicle.others_index.toFixed(2)),
          },
        ],
      };
    },
  },
  mounted() {
    this.canCreate = true;
    if (this.culture) {
      this.loadCicles();
      this.loadCiclesOptions();
    }
  },
  watch: {
    selectedCicle(newCicle) {
      for (const index in this.cicles) {
        if (this.cicles[index].id == newCicle.id) {
          this.cicles[index] = newCicle;
        }
      }
    },
    client(newClient) {
      this.loadCicles();
    },
    crop(anosafra) {
      this.loadCicles(anosafra.id);
    },
    cicleChoose() {
      this.editCicle(item)
    },
  },
};
</script>
